/* global JSX */
// ConfirmationDialog
import CloseIcon from "@mui/icons-material/Close";
import { DialogActions, DialogContent, DialogTitle, Grid, IconButton, TextField, Typography } from "@mui/material";
import React from "react";
import { ConfirmationDialogType } from "source/models/store/storeTypes";
import { Base } from "ui/Scripts/source/framework/base";
import { Translations } from "ui/Scripts/source/models/translations";
import { ConfirmationButton } from "../../Button/ConfirmationButton";
import { DraggablePaper } from "../DraggablePaper";
import { GridRow } from "../../Grid/GridRow";
import { AppBaseDialog } from "../AppBaseDialog";
import { AppButton } from "ui/Scripts/source/components/framework/Button/AppButton";

// ***********************************************************************************************************************
export interface IConfirmationDialogCallback {
    (): void;
}

export interface IConfirmationDialogCall {
    (title: string, text: any, yesCallback: IConfirmationDialogCallback, noCallback: IConfirmationDialogCallback): void;
}

export interface IConfirmationDialogProp {
    classes?: string;
    type: ConfirmationDialogType;
    title: string;
    text: string | JSX.Element;
    yesConfirmationText?: string;
    onYes: IConfirmationDialogCallback;
    onNo: IConfirmationDialogCallback;
    onCancel: IConfirmationDialogCallback;
}

export interface IConfirmationDialogState {
    confirmation: string;
}

export class ConfirmationDialog extends React.Component<IConfirmationDialogProp, IConfirmationDialogState> {
    constructor(props) {
        super(props);
        this.state = { confirmation: "" };
    }

    handleChange = (event) => {
        const target = event.target;
        const value: string = target.value;
        const name: string = target.name;
        if (name === "confimation") {
            this.setState({ confirmation: value });
        }
    };

    render() {
        const props = this.props;
        const state = this.state;
        return (
            <AppBaseDialog open onClose={props.onCancel ? props.onCancel : props.onNo} PaperComponent={(props) => <DraggablePaper id={"draggable-dialog-title"} props={props} />}>
                <DialogTitle style={{ cursor: "move" }} id="draggable-dialog-title">{props.title}</DialogTitle>
                <DialogContent>
                    {Base.isString(props.text) && props.yesConfirmationText
                        ? <GridRow>
                            <Grid item sm={12}>
                                <Typography sx={{ whiteSpace: "pre-wrap" }}>{props.text}</Typography>
                            </Grid>
                            <Grid item sm={12}>
                                <Typography sx={{ marginBottom: "1rem" }}>{String.format(Translations.WriteBelowFieldWordParameterToConfirmTheOperation, props.yesConfirmationText)}</Typography>
                                <TextField type="text" name="confimation" title={String.format(Translations.WriteBelowFieldWordParameterToConfirmTheOperation, props.yesConfirmationText)} inputProps={{ maxLength: props.yesConfirmationText.length }} value={state.confirmation} onChange={this.handleChange} fullWidth autoFocus />
                            </Grid>
                        </GridRow>
                        : props.text
                    }
                </DialogContent>
                <IconButton
                    aria-label="close"
                    onClick={props.onCancel ? props.onCancel : props.onNo}
                    sx={{
                        position: "absolute",
                        right: 8,
                        top: 8,
                        color: (theme) => theme.palette.grey[500],
                    }}
                >
                    <CloseIcon />
                </IconButton>
                <DialogActions>
                    {!Base.isNullOrUndefined(props.onCancel) && (
                        <AppButton variant="outlined" onClick={props.onCancel} sx={{ marginRight: "1rem" }}>
                            {Translations.Cancel}
                        </AppButton>
                    )}
                    <AppButton variant="outlined" onClick={props.onNo}>
                        {Translations.No}
                    </AppButton>
                    <ConfirmationButton onClick={props.onYes} disabled={!!props.yesConfirmationText && !state.confirmation.equalIgnoreCase(props.yesConfirmationText)}>
                        {Translations.Yes}
                    </ConfirmationButton>
                </DialogActions>
            </AppBaseDialog>
        );
    }
}